
<template>
  <div id="flipdish-menu" data-restaurant="fd8933">
    <!-- Loading message -->
    <div
      style="font-size:3.5vh; position:absolute; left:50%; top:50%; transform: translate(-50%, -50%) "
    >{{getTranslation('loading')}}</div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      restaurant_id: "tajmahalsevilla"
    };
  },
  methods: {
    dynamicallyLoadScript(url) {
      var script = document.createElement("script"); // create a script DOM node
      script.src = url; // set its src to the provided URL
      document.head.appendChild(script);
    },
    // Get translation must be first if used in other methods
    getTranslation(key) {
      return this.$t(key);
    }
  },
  created() {
    this.dynamicallyLoadScript(
      "https://web-order.flipdish.co/client/productionwlbuild/latest/static/js/main.js"
    );
  }
};
</script>

<style scoped>
@import "custom_styles.css";
</style>


// WEBPACK FOOTER //
// src/components/DeliveryPage.vue